module.exports = __webpack_public_path__ + "img/xzy01.5596c327.png";